import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const SaseTanimlama = () => {
    return (
        <>
            <ExcelUpload
                requiredColumnsSase={["sase", "Marka", "Commercial denomination Code", "Car line", "Commercial Denomination name", "Colour code", "Colour name", "Gemi Adı", "Gemi Varış Tarihi", "pdi"]}
                process_type="VEHICLE"
                ExcelName={"Şase Tanımlama Hatalı Şaseler"}
                Title={"Şase Tanımlama"}
                role_name={"sase_tanimlama_write"}
                exampleData={[
                    {
                        "sase": "VF3YEF6F0RMA03711",
                        "Marka": "PEUGEOT",
                        "Commercial denomination Code": "2PXE7MHOKKB0A0",
                        "Car line": "Boxer (XE)",
                        "Commercial Denomination name": "Yeni BOXER VAN L4H2 2.2 BlueHDi 140hp S&S (15 m3) 4T",
                        "Colour code": "PRP0",
                        "Colour name": "BEYAZ (Buz)",
                        "Gemi Adı": "BAYİ",
                        "Gemi Varış Tarihi": "01.01.2024",
                        "pdi": "1/0"
                    }
                ]}

            />
        </>
    )
}

export default SaseTanimlama
